import { Shield } from 'lucide-react';
import styles from './OrgSwitcherGroup.module.css';

export const OrganizationLogo = ({ name, logoUrl }: { name: string; logoUrl?: string | null }) => (
  <span className={styles.logo}>
    {logoUrl ? <img src={logoUrl} alt={`${name} logo`} /> : <Shield aria-hidden />}
  </span>
);
